// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G0pZ","colBig":"styles_colBig__25Of1","colSmall":"styles_colSmall__2_mA1"};